import * as React from 'react';
import { createComponent } from '@lit/react';
import { ButtonWithoutGhostWC } from './button-without-ghost.wc';

export const ButtonWithoutGhost = createComponent({
  tagName: ButtonWithoutGhostWC.tagname,
  elementClass: ButtonWithoutGhostWC,
  react: React,
});
